import { FormattedMessage } from "react-intl";
import { cloneDeep } from 'lodash';

export const checkEnvironment = process.env.REACT_APP_RUNNING_CONTEXT;
export const checkMockup = process.env.REACT_APP_IS_MOCKUP;

export const defaultMacAddressItem = {
  macAddress: "",
  snInformation: "",
  macAddressDirty: false
}

export const defaultMacAddressObj = {
  siteId: "",
  macAddresses: [
    // Generate 1 default items
    ...Array.from({ length: 1 }, () => cloneDeep(defaultMacAddressItem))
  ],
}